import { connect } from 'react-redux';
import {
    CheckoutLifecycleEventPostMessageName,
    checkoutPostMessage,
} from '@eventbrite/checkout-postmessage-api';
import { navigateToTicketSelection as navigateToTicketSelectionAction } from '../../actions/initialize';
import { notifyParentWidgetModalClose as notifyParentWidgetModalCloseAction } from '../../actions/notifyParent';
import {
    abandonOrder as abandonOrderAction,
    backToPathOnCancelAbandonOrder as backToPathOnCancelAbandonOrderAction,
    backToLogin,
} from '../../actions/order/common';
import { navigateToSeriesPage as navigateToSeriesPageAction } from '../../actions/series';
import { queueFree as queueFreeAction } from '../../actions/waitingRoom';
import {
    CHECKOUT_PATH,
    DELIVERY_METHODS_PATH,
    LOGIN_PATH,
    PICK_A_SEAT_PATH,
    RESERVED_TICKETS_CONFIRMATION_PATH,
} from '../../constants';
import { shouldShowBackToSeriesLink } from '../series/utils';
import {
    getFeatureFlags,
    getIsAppRebrandActive,
    isNativeApp,
} from '../../selectors/app';
import {
    getEventTitle,
    getFormattedEventDate,
    getEventSalesStatus,
} from '../../selectors/event';
import { shouldNavigateToTicketSelectionWhenClosingModal } from '../../selectors/app';

const _mapStateToProps = (state, ownProps) => ({
    eventDate: getFormattedEventDate(state),
    eventTitle: getEventTitle(state),
    featureFlags: getFeatureFlags(state),
    isAppRebrandActive: getIsAppRebrandActive(state),
    isNativeApp: isNativeApp(state),
    shouldNavigateToTicketSelectionWhenClosingModal:
        shouldNavigateToTicketSelectionWhenClosingModal(state),
    shouldShowBackToSeriesLink: shouldShowBackToSeriesLink(state),
    statusType: ownProps.routeParams.statusType,
    ...getEventSalesStatus(state),
});

const _mapDispatchToProps = (dispatch) => ({
    // XXX: I find it a little weird to mix these "confirm action" pages with just event statuses,
    // especially since those pages don't need these props. Ticket for refactoring this: EB-59924
    closeModalActions: (shouldNavigateToTicketSelectionWhenClosingModal) =>
        dispatch(abandonOrderAction())
            .then(() => dispatch(queueFreeAction()))
            .then(() =>
                shouldNavigateToTicketSelectionWhenClosingModal
                    ? dispatch(navigateToTicketSelectionAction())
                    : dispatch(notifyParentWidgetModalCloseAction()),
            ),
    closeModalOnNativeActions: () =>
        dispatch(abandonOrderAction())
            .then(() => dispatch(queueFreeAction()))
            .then(() => dispatch(notifyParentWidgetModalCloseAction()))
            .then(() =>
                checkoutPostMessage({
                    messageName:
                        CheckoutLifecycleEventPostMessageName.orderStatusCanceled,
                }),
            ),
    toLogin: () => dispatch(backToPathOnCancelAbandonOrderAction(LOGIN_PATH)),
    toTicketSelection: () =>
        dispatch(abandonOrderAction())
            .then(() => dispatch(queueFreeAction()))
            .then(() => dispatch(navigateToTicketSelectionAction())),
    toTicketSelectionFromInterstitial: () =>
        dispatch(navigateToTicketSelectionAction()),
    toCheckout: () => {
        dispatch(backToPathOnCancelAbandonOrderAction(CHECKOUT_PATH));
    },
    toInterstitial: () => {
        dispatch(backToLogin());
    },
    toDeliveryMethod: () =>
        dispatch(backToPathOnCancelAbandonOrderAction(DELIVERY_METHODS_PATH)),
    toPickASeat: () =>
        dispatch(backToPathOnCancelAbandonOrderAction(PICK_A_SEAT_PATH)),
    toReservedTicketConfirmation: () =>
        dispatch(
            backToPathOnCancelAbandonOrderAction(
                RESERVED_TICKETS_CONFIRMATION_PATH,
            ),
        ),
    onBackToSeries: () => dispatch(navigateToSeriesPageAction()),
});

export const connectStatusPage = (ComponentClass) =>
    connect(_mapStateToProps, _mapDispatchToProps)(ComponentClass);
